export default __webpack_public_path__ + "locales/cs/Translations.json?hash=928d64a12571c1a920c82cea547096bb";